import { ListIcon } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Sheet } from "@/components/ui/sheet";
import { Text } from "@/components/ui/text";
import { InsightsExamplesList } from "./InsightsExamplesList";

type InsightsExamplesSheetProps = {
  examples: readonly string[];
  onSelect: (example: string) => void;
  isDisabled?: boolean;
  className?: string;
};

export function InsightsExamplesSheet({
  examples,
  onSelect,
  isDisabled = false,
  className,
}: InsightsExamplesSheetProps) {
  const [open, setOpen] = React.useState(false);

  if (examples.length === 0) return null;

  function handleSelect(example: string) {
    onSelect(example);
    setOpen(false);
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        isDisabled={isDisabled}
        className={className}
        onPress={() => setOpen(true)}
      >
        <ListIcon />
        Examples
      </Button>
      <Sheet
        isOpen={open}
        onOpenChange={setOpen}
        side="right"
        classNames={{
          content: "left-2 w-auto sm:left-auto sm:right-2 sm:max-w-lg",
        }}
      >
        <Dialog>
          <DialogHeader className="border-b">
            <DialogTitle>Example questions</DialogTitle>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-3 py-4">
            <Text size="2" muted>
              Pick a question to run it in Insights.
            </Text>
            <InsightsExamplesList
              examples={examples}
              onSelect={handleSelect}
              isDisabled={isDisabled}
              maxListHeightClassName="max-h-[min(70vh,32rem)]"
            />
          </DialogBody>
        </Dialog>
      </Sheet>
    </>
  );
}
